import React from "react"
import DfbImage from "../ui-kit/dfb_image"
import DfbRte from "../ui-kit/dfb_rte"
import CLightbox from "./c_lightbox"
import CMediaVideo from "./c_media_video"
import { wrapListItemContents } from "../utilities"
import { Transformation } from "cloudinary-react"

const CMediaTextSliderSwitchedMediaIndicators = ({ items }) => {
  return (
    <div className="c-MediaTextSlider-indicatorContainer">
      <div className="dfb-Indicators dfb-Indicators--secondary u-Theme-dark c-MediaTextSlider-indicators">
        {items.map((innerslide, innerindex) => {
          return (
            <button
              key={`media-indicator-${innerindex}`}
              className={`dfb-Indicators-item ${
                innerindex === 0 ? "is-active" : ""
              }`}
              data-indicatoritem={innerindex}
            >
              <span className="dfb-Indicators-itemInner"></span>
            </button>
          )
        })}
      </div>
    </div>
  )
}

const CMediaTextSliderSwitchedMedia = ({ mediaContent, items }) => {
  if (mediaContent.image) {
    return (
      <div className="c-MediaTextSlider-mediaContainer">
        <div
          data-toggle="modal"
          data-target={`c-MediaTextSlider-media-image-${mediaContent.image.uid}`}
        >
          <DfbImage image={mediaContent.image} aspect_ratio="16:9">
            <Transformation
              crop="fill"
              gravity="faces:center"
              width="720"
              height="405"
              quality="auto"
              fetchFormat="auto"
            />
          </DfbImage>
        </div>
        <CLightbox
          id={`c-MediaTextSlider-media-image-${mediaContent.image.uid}`}
          image={mediaContent.image}
          width="1600"
          height="900"
        ></CLightbox>
        {items && items.length > 1 && (
          <CMediaTextSliderSwitchedMediaIndicators items={items} />
        )}
      </div>
    )
  } else if (mediaContent.video_embed_id) {
    return (
      <div className="c-MediaTextSlider-mediaContainer">
        <CMediaVideo video_embed_id={mediaContent.video_embed_id} />
        {items && items.length > 1 && (
          <CMediaTextSliderSwitchedMediaIndicators items={items} />
        )}
      </div>
    )
  }
}

const CMediaTextSliderTabs = ({ tabs, outerIndex, parent_uid }) => {
  return (
    <div className="c-MediaTextSlider-tabs">
      {tabs && tabs.length && tabs.length > 1 && (
        <div className="c-MediaTextSlider-tabContainer">
          <div className="dfb-Tabs dfb-Tabs--simple m-Tab-tabs">
            <div className="dfb-Tabs-scroller">
              <div className="dfb-Tabs-scrollArea">
                <div className="dfb-Tabs-scrollContent">
                  <ul className="dfb-Tabs-list" role="tablist">
                    {tabs.map((tab, index) => {
                      return (
                        <li
                          key={`media-tab-list-tab-${index}`}
                          className="dfb-Tabs-item"
                        >
                          <a
                            className="dfb-Tabs-tab"
                            href={
                              "#MediaTextSlider-tabs-" +
                              parent_uid +
                              outerIndex +
                              "-panel-" +
                              index
                            }
                            id={
                              "MediaTextSlider-tabs-" +
                              parent_uid +
                              outerIndex +
                              "-tab-" +
                              index
                            }
                            tabIndex={index > 0 ? -1 : 0}
                            aria-selected="true"
                            role="tab"
                          >
                            <div className="dfb-Tabs-labelContainer">
                              <span className="dfb-Tabs-tabLabel">
                                {tab.media_text_slider_item_tab_title}
                              </span>
                            </div>
                          </a>
                        </li>
                      )
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="c-MediaTextSlider-panelContainer">
        {tabs.map((tab, index) => {
          return (
            <div
              key={`media-tab-list-panel-${index}`}
              className={`dfb-TabsPanel c-MediaTextSlider-panel m-Tab-panel${
                tabs.length === 1 ? " is-active" : ""
              }`}
              id={
                "MediaTextSlider-tabs-" +
                parent_uid +
                outerIndex +
                "-panel-" +
                index
              }
              role="tabpanel"
              tabIndex="0"
              aria-labelledby={
                "MediaTextSlider-tabs-" +
                parent_uid +
                outerIndex +
                "-tab-" +
                index
              }
            >
              {tab.media_text_slider_item_tab_content.map(
                (rteItem, innerindex) => {
                  return (
                    <React.Fragment
                      key={`media-tab-list-panel-rte-${innerindex}`}
                    >
                      <DfbRte text={wrapListItemContents(rteItem.text)} />
                    </React.Fragment>
                  )
                }
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

const CMediaTextSlider = ({ data }) => {
  const { media_text_slider_item, uid } = data

  return (
    <div className="c-MediaTextSlider">
      <div className="c-MediaTextSlider-slider">
        {media_text_slider_item && media_text_slider_item.length > 0 && (
          <>
            <ul className="c-MediaTextSlider-slides">
              {media_text_slider_item.map((slide, outerindex) => {
                return (
                  <li
                    key={`media-slider-item-${outerindex}`}
                    className="c-MediaTextSlider-item"
                  >
                    {slide.media_text_slider_item_content &&
                      slide.media_text_slider_item_content.length > 0 && (
                        <CMediaTextSliderSwitchedMedia
                          mediaContent={slide.media_text_slider_item_content[0]}
                          items={media_text_slider_item}
                        />
                      )}

                    {slide.media_text_slider_item_subline && (
                      <h4 className="dfb-Headline dfb-Headline--h4 c-MediaTextSlider-headline">
                        {slide.media_text_slider_item_subline}
                      </h4>
                    )}

                    {slide.media_text_slider_item_tab &&
                      slide.media_text_slider_item_tab.length > 0 && (
                        <CMediaTextSliderTabs
                          tabs={slide.media_text_slider_item_tab}
                          outerIndex={outerindex}
                          parent_uid={uid}
                        />
                      )}
                  </li>
                )
              })}
            </ul>
            <ul className="c-MediaTextSlider-controls">
              <li className="c-MediaTextSlider-controlElement c-MediaTextSlider-previousControlElement">
                <button
                  className="dfb-Button dfb-Button--icon"
                  type="button"
                  aria-label="previous"
                >
                  <span className="dfb-Button-icon">
                    <svg
                      className="dfb-Symbol dfb-Symbol--dfbIconDropdownLeft"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                    >
                      <use
                        xlinkHref="#dfb-icon-dropdown-left"
                        href="#dfb-icon-dropdown-left"
                      ></use>
                    </svg>
                  </span>
                </button>
              </li>
              <li className="c-MediaTextSlider-controlElement c-MediaTextSlider-nextControlElement">
                <button
                  className="dfb-Button dfb-Button--icon"
                  type="button"
                  aria-label="next"
                >
                  <span className="dfb-Button-icon">
                    <svg
                      className="dfb-Symbol dfb-Symbol--dfbIconDropdownRight"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                    >
                      <use
                        xlinkHref="#dfb-icon-dropdown-right"
                        href="#dfb-icon-dropdown-right"
                      ></use>
                    </svg>
                  </span>
                </button>
              </li>
            </ul>
          </>
        )}
      </div>
    </div>
  )
}

export default CMediaTextSlider
